<template>
  <van-sticky>
    <van-nav-bar :title="title" left-arrow @click-left="onClickLeft" />
  </van-sticky>
</template>

<script>
export default {
  data(){
    return {
      title:'瑞房智评'
    }
  },
  // created() {
  //   this.getTitle();
  // },
  methods: {
    // getTitle() {
    //   var that = this;
    //   this.$axios.get("http://xrt.com/api/title").then(
    //     function (response) {
    //       that.title = response.data;
    //     },
    //     function (err) {
    //       console.log(err);
    //     }
    //   );
    // },
    onClickLeft() {
      if (window.history.length > 1) {
        history.go(-1);
      } else {
        history.go("/");
      }
    },
  },
};
</script>